import { Subscribable, SubscribableOrNullableValue } from 'knockout';
import { IWCCStorageManager } from 'managers/iStorage';

export interface WCCContentContextConfig {
    topicId?: SubscribableOrNullableValue<string | undefined>
}

export interface IWCCContentContext {
    storage: IWCCStorageManager

    topicId: Subscribable<string | undefined>    
}

export default class WCCContentContext implements IWCCContentContext {
    topicId: Subscribable<string | undefined>

    constructor(public storage: IWCCStorageManager, config?: WCCContentContextConfig) {
        this.topicId = ko.flattenComputed(config?.topicId);
    }
}